<script>
  export let title = '';
  export let value = '';
  export let change = '';
  export let changeType = 'positive'; // 'positive' or 'negative'
  export let subtitle = '';
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <div class="flex items-center justify-between mb-2">
    <h3 class="text-sm font-medium text-gray-500">{title}</h3>
  </div>

  <div class="flex items-end justify-between">
    <div>
      <p class="text-3xl font-bold text-gray-900">{value}</p>
      {#if subtitle}
        <p class="text-xs text-gray-500 mt-1">{subtitle}</p>
      {/if}
    </div>

    {#if change}
      <div class="flex items-center gap-1">
        <span class="text-sm font-medium {changeType === 'positive' ? 'text-green-600' : 'text-red-600'}">
          {change}
        </span>
        <span class="text-xs text-gray-500">vs last week</span>
      </div>
    {/if}
  </div>
</div>
